<template>
  <div class="container">
    <h1>👋&nbsp;<span id="hey">Hey!</span></h1>
    <div class="hero" :style="heroStyle">
      <img src="@/assets/image/memoji_avatar.png" alt="avatar">
      <h2>code & design</h2>
    </div>
    <div class="grid">
      <div id="red"></div>
      <div id="orange"></div>
      <div id="yellow"></div>
      <div id="green"></div>
      <div id="teal"></div>
      <div id="blue"></div>
      <div id="purple"></div>
      <div id="pink"></div>
      <div id="more">
        <p>MORE</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Homepage",
  data() {
    return {
      scrollY: 0,
      isDesktop: false,
      animationFrame: null
    }
  },
  computed: {
    heroStyle() {
      if (!this.isDesktop) return {};
      
      // 计算hero区域到第一个方块的距离，让它消失得更慢一些（慢一倍）
      const fadeDistance = 144;
      const opacity = Math.max(0, 1 - (this.scrollY / fadeDistance));
      const translateY = this.scrollY * 0.5;
      
      return {
        opacity: opacity,
        transform: `translate(-50%, ${translateY}px)`,
        zIndex: 1
      };
    }
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.checkScreenSize);
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
  },
  methods: {
    goto(address) {
      window.location.href = address;
    },
    handleScroll() {
      // 使用requestAnimationFrame优化滚动性能
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }
      
      this.animationFrame = requestAnimationFrame(() => {
        this.scrollY = window.scrollY;
      });
    },
    checkScreenSize() {
      this.isDesktop = window.innerWidth > 860;
    }
  }
}
</script>

<style scoped>
.container {
  --h1-color: rgba(0, 0, 0, .75);
  --h2-color: rgba(0, 0, 0, .75);
}

@media (prefers-color-scheme: dark) {
  .container {
    --h1-color: rgba(255, 255, 255, 1);
    --h2-color: rgba(255, 255, 255, 1);
  }
}

/* === Layouts === */

.container {
  width: 860px;
  margin: 0 auto;
  padding: 24px 24px 0 24px;
}

@media (min-width: 861px) {
  .container {
    padding-top: 24px;
    min-height: 100vh;
    position: relative;
  }
}

h1 {
  font-size: 48px;
  line-height: 1.5em;
  font-weight: 800;
  margin-top: 24px;
}
h1 #hey {
  /* color: var(--h1-color); */
  color: rgba(255, 255, 255, .1);
  text-shadow: rgba(0, 0, 0, .16) 0 6px 6px;
  background-image: url("../assets/image/soberstudio_logo.png");
  /* background-size: cover; */
  background-position: center;
  background-size: 135%;
  background-clip: content-box;
  -webkit-background-clip: text;
}

.hero {
  text-align: center;
  margin: 40px 0;
  transition: opacity 0.1s linear, transform 0.1s linear;
  will-change: opacity, transform;
  transform: translateZ(0); /* 强制启用硬件加速 */
}

@media (min-width: 861px) {
  .hero {
    position: absolute;
    top: 120px;
    left: 50%;
    transform: translateX(-50%);
    margin: 0;
    height: 200px;
    width: 100%;
    will-change: opacity, transform;
    transform: translateX(-50%) translateZ(0); /* 强制启用硬件加速 */
  }
}

.hero img {
  width: 160px;
}

.hero h2 {
  font-size: 32px;
  font-weight: 100;
  color: var(--h2-color);
  text-shadow: rgba(0, 0, 0, .16) 0 6px 6px;
}

h1, .hero h2 {
  cursor: default;
}

.grid {
  margin: 60px 0 80px 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 2;
}

@media (min-width: 861px) {
  .grid {
    margin: 240px 0 80px 0;
  }
}

.grid div {
  width: 260px;
  height: 130px;
  background-color: white;
  margin-bottom: 24px;
  border-radius: 6px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  background-image: radial-gradient(ellipse at 130px 0px, rgba(255, 255, 255, .3) 0%, rgba(255, 255, 255, 0) 100%);
  cursor: pointer;
}

.grid div {
  transition-duration: .5s;
  transition-timing-function: ease-in-out;
}

.grid div:hover {
  transform: translateY(-5px);
  box-shadow: 0 3px 6px rgba(0, 5, 5, 0.24);
}

#more p {
  margin: 0;
  font-size: 32px;
  font-weight: 100;
  line-height: 130px;
}

@media (max-width: 860px) {
  .container {
    width: 560px;
    padding: 20px 12px 0 12px;
    min-height: auto;
  }

  .hero {
    margin: 30px 0;
    position: static;
    top: auto;
    left: auto;
    transform: none;
    height: auto;
  }

  .grid {
    margin: 40px 0 60px 0;
    position: static;
    z-index: auto;
  }

  .grid div {
    margin-bottom: 18px;
  }

  h1 {
    font-size: 32px;
    text-align: center;
    margin-top: 20px;
  }

  .hero img {
    width: 80px;
  }

  .hero h2 {
    font-size: 12px;
  }

  h1, .hero h2 {
    cursor: default;
  }

  #more {
    width: 536px;
    height: 75px;
  }

  #more p {
    line-height: 75px;
  }
}

@media (max-width: 560px) {
  .container {
    width: 326px;
    padding: 16px 12px 0 12px;
    min-height: auto;
  }

  .hero {
    margin: 20px 0;
    position: static;
    top: auto;
    left: auto;
    transform: none;
    height: auto;
  }

  .grid {
    margin: 30px 0 40px 0;
    position: static;
    z-index: auto;
  }

  .grid div {
    margin-bottom: 12px;
  }

  h1 {
    font-size: 24px;
    text-align: center;
    margin-top: 16px;
  }

  .hero img {
    width: 80px;
  }

  .hero h2 {
    font-size: 12px;
  }

  h1, .hero h2 {
    cursor: default;
  }

  .grid div {
    width: 146px;
    height: 74px;
    margin-top: 10px;
  }

  #more {
    width: 302px;
    height: 48px;
    margin-top: 20px;
  }

  #more p {
    font-size: 16px;
    line-height: 48px;
  }
}

/* === Colors === */

#red {
  background-color: #ff3b30;
}

#orange {
  background-color: #ff9500;
}

#yellow {
  background-color: #ffcc00;
}

#green {
  background-color: #4cd964;
}

#teal {
  background-color: #5ac8fa;
}

#blue {
  background-color: #007aff;
}

#purple {
  background-color: #5856d6;
}

#pink {
  background-color: #ff2d55;
}

#more {
  background-color: #F5F5F7;
  background-image: radial-gradient(ellipse at 130px 0px, rgba(0, 0, 0, 0.02) 0%, rgba(0, 0, 0, 0.05) 100%);
  text-align: center;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

@media (prefers-color-scheme: dark) {
  #more {
    background-color: #2C2C2E;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background-image: radial-gradient(ellipse at 130px 0px, rgba(255, 255, 255, 0.02) 0%, rgba(255, 255, 255, 0.05) 100%);
  }
}
</style>
